<div class="side-sheet" [ngClass]="{'active': selectedReviewId}">
    <div class="d-flex h-100">

        <div class="overlay" (click)="close.emit()"></div>

        <div class="sheet-container">
            <div class="sheet-head">
                <div class="title">{{'content4.Review Details' | translate}}</div>

                <button type="button" mat-icon-button (click)="close.emit()">
                    <img src="./assets/images/icons/close.svg" alt="">
                </button>
            </div>
            <div *ngIf='dataLoading' class="dataLoading">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
            </div>

            <ng-container *ngIf="!dataLoading && review">
                <div class="sheet-content p-0">
                    <div class="review-details">
                        <div class="user-details-card">
                          <div class="d-flex align-items-center justify-content-between">
                            <div class="name-with-image">
                                <div class="image-circle">
                                    <img *ngIf="review.reviewIcon" [src]="review.reviewIcon"
                                        (error)="review.reviewIcon = ''">
                                    <span *ngIf="!review.reviewIcon">{{ review.reviewName | shortName }}</span>
                                </div>
                                <div class="name">
                                    <p class="font-16 fontMedium text-color">{{review.reviewName}}</p>
                                </div>
                            </div>

                            <div>
                              <button mat-icon-button *ngIf="review.canReport" (click)="openReportForm()">
                                <mat-icon class="red-color">flag</mat-icon>
                              </button>

                              <div class="status-badge grey" *ngIf="review.reportStatus == 'Reported'">{{'reviews.Reported' | translate}}</div>
                              <div class="status-badge orange" *ngIf="review.reportStatus == 'Resolved'">{{'reviews.Resolved' | translate}}</div>
                            </div>
                          </div>

                          <div class="info-with-background" *ngIf="review.isPostedanonymously">
                              <p class="info font-14 fontMedium dark-grey-color">{{'content4.Posted anonymously' | translate}}</p>
                          </div>
                          <hr>
                          <p class="font-14 fontRegular grey-color">{{'content4.Posted on' | translate}}</p>
                          <p class="font-16 fontMedium text-color">
                            {{review.reviewDate | date:'d MMMM, y'}} {{'content4.at' | translate }} {{review.reviewDate | date:'shortTime'}}
                        </p>
                        </div>

                        <ng-container *ngIf="review.reviewReport">
                          <div class="user-details-card">
                            <p class="font-14 grey-color">{{'reviews.Reported by' | translate}}</p>
                            <div class="name-with-image thumb">
                              <div class="image-circle mr-2">
                                <span *ngIf="!review.reviewReport.reportedbyIcon">{{ review.reviewReport.reportedbyName | shortName }}</span>
                                <img *ngIf="review.reviewReport.reportedbyIcon" [src]="review.reviewReport.reportedbyIcon" (error)="review.reviewReport.reportedbyIcon = ''">
                              </div>
                              <div class="name">
                                <p class="font-16 fontMedium text-color">{{review.reviewReport.reportedbyName}}</p>
                              </div>
                            </div>

                            <hr class="my-3">

                            <div>
                              <p class="font-14 grey-color">{{'reviews.Reported on' | translate}}</p>
                              <p class="font-16 fontMedium text-color">
                                <!-- {{review.reviewReport.reportDate | date:'d MMM, y - h:mm a'}} -->
                                {{review.reviewReport.reportDate | date:'d MMMM, y'}} {{'content4.at' | translate }} {{review.reviewReport.reportDate | date:'shortTime'}}
                            </p>
                            </div>
                          </div>

                          <div class="my-3">
                            <p class="font-14 grey-color">{{'reviews.Report Review Details' | translate}}</p>
                            <p class="font-16 text-color">{{review.reviewReport.reportReasones}}</p>
                            <p class="font-14 text-color mt-2">{{review.reviewReport.reportComment}}</p>
                          </div>
                          <!-- <hr> -->
                        </ng-container>

                        <div class="card-yellow mt-4" *ngIf="review.reportStatus == 'Resolved'">
                          <div class="card-head">{{'reviews.Resolution' | translate}}</div>
                          <div class="card-content">

                            <div>
                              <p class="font-14 grey-color">{{'reviews.Resolved by' | translate}}</p>
                              <div class="name-with-image thumb">
                                <div class="image-circle mr-2">
                                  <span *ngIf="!review.reportDecision[0].resolvedbyIcon">{{ review.reportDecision[0].resolvedbyName | shortName }}</span>
                                  <img *ngIf="review.reportDecision[0].resolvedbyIcon" [src]="review.reportDecision[0].resolvedbyIcon" (error)="review.reportDecision[0].resolvedbyIcon = ''">
                                </div>
                                <div class="name">
                                  <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolvedbyName}}</p>
                                </div>
                              </div>
                            </div>

                            <hr>

                            <div>
                              <p class="font-14 grey-color">{{'reviews.Resolution' | translate}}</p>
                              <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolution}}</p>
                            </div>

                            <hr>

                            <div>
                              <p class="font-14 grey-color">{{'reviews.Resolved on' | translate}}</p>
                              <p class="font-16 fontMedium text-color">
                                <!-- {{review.reportDecision[0].resolvedDate | date}} -->
                                {{review.reportDecision[0].resolvedDate | date:'d MMMM, y'}} {{'content4.at' | translate }} {{review.reportDecision[0].resolvedDate | date:'shortTime'}}
                            </p>
                            </div>

                            <hr>

                            <div>
                              <p class="font-14 grey-color">{{'forms.Notes' | translate}}</p>
                              <p class="font-16 fontMedium text-color">{{review.reportDecision[0].resolutionComment}}</p>
                            </div>


                            <div class="d-flex ml-auto justify-content-end mt-3" *ngIf="review.reportDecision.length > 1">
                                <button class="btn dropdown-custom" (click)="showHistory = !showHistory">
                                  <span class="pr-2">
                                    <ng-container *ngIf="!showHistory">
                                      {{"reviews.Show History" | translate}}
                                    </ng-container>
                                    <ng-container *ngIf="showHistory">
                                      {{"reviews.Hide History" | translate}}
                                    </ng-container>
                                  </span>
                                </button>
                              </div>
                              
              
                              <!-- HISTORY -->
                              <ng-container *ngIf="showHistory">
                                <div *ngFor="let decision of review.reportDecision | slice:1; last as isLast" class="mb-3">
                                <hr class="orange-border">

                                  <div>
                                    <p class="font-14 grey-color">{{'reviews.Resolved by' | translate}}</p>
                                    <div class="name-with-image thumb">
                                      <div class="image-circle mr-2">
                                        <span *ngIf="!decision.resolvedbyIcon">{{ decision.resolvedbyName | shortName }}</span>
                                        <img *ngIf="decision.resolvedbyIcon" [src]="decision.resolvedbyIcon" (error)="decision.resolvedbyIcon = ''">
                                      </div>
                                      <div class="name">
                                        <p class="font-16 fontMedium text-color">{{decision.resolvedbyName}}</p>
                                      </div>
                                    </div>
                                  </div>
                  
                                  <hr>
                  
                                  <div>
                                    <p class="font-14 grey-color">{{'reviews.Resolution' | translate}}</p>
                                    <p class="font-16 fontMedium text-color">{{decision.resolution}}</p>
                                  </div>
                  
                                  <hr>
                  
                                  <div>
                                    <p class="font-14 grey-color">{{'reviews.Resolved on' | translate}}</p>
                                    <p class="font-16 fontMedium text-color">
                                      <!-- {{record.reportDecision.resolvedDate | date}} -->
                                      {{decision.resolvedDate | date:'d MMM, y'}} {{'guests.at' | translate }} {{decision.resolvedDate | date:'shortTime'}}
                                    </p>
                                  </div>
                  
                                  <hr>
                  
                                  <div>
                                    <p class="font-14 grey-color">{{'forms.Notes' | translate}}</p>
                                    <p class="font-16 fontMedium text-color">{{decision.resolutionComment}}</p>
                                  </div>
              
                                  <!-- <hr class="orange-border" *ngIf="!isLast"> -->
                                </div>
                              </ng-container>

                          </div>
                        </div>

                        <div class="reservation d-flex">
                            <span class="font-14 fontRegular grey-color">{{'reservations.Reservation' | translate}} #:
                              <span class="font-16 fontMedium text-color">{{ review.reservationNumber }}</span>
                            </span>
                            <a (click)="selectedReservationId = review.reservationId" class="ml-auto font-14 fontRegular grey-color d-flex align-items-center">
                              <span>{{'general.View' | translate}}</span>
                              <img src="./assets/images/icons/open_in_new_black_24dp.svg">
                            </a>
                        </div>

                        <div class="rating mt-4">
                            <div class="rate-item d-flex align-items-center">
                                <span class="font-16 fontRegular text-color">
                                  {{'content4.Overall rating of the restaurant' | translate}}</span>

                                <div class="ml-auto">
                                  <ng-container *ngIf="review.reviewRate; else skipped">
                                    <img src="./assets/images/icons/stars.svg" alt="">
                                    <span class="font-16 fontRegular text-color mt-1 ml-2">
                                        {{review.reviewRate}}
                                    </span>
                                  </ng-container>
                                  <ng-template #skipped>{{ 'reviews.skipped' | translate }}</ng-template>
                                </div>
                            </div>

                        </div>

                    </div>

                    <ng-container *ngIf="review.orderedItems?.length">
                      <div class="heads">
                          <p>{{'stockManagement.Ordered Items' | translate}}</p>
                      </div>

                      <div class="rating-list">
                          <div class="rate-item d-flex" *ngFor="let order of review.orderedItems">

                              <div class="img-card">
                                  <span *ngIf="!order.orederItemIcon">{{ order.orderItemName | shortName }}</span>
                                  <img class="d-block m-auto" *ngIf="order.orederItemIcon" [src]="order.orederItemIcon"
                                      (error)="order.orederItemIcon = ''">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">{{order.orderItemName}}</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">{{order.orderItemRate}}</span>
                          </div>
                          <!-- <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/item photo.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div>
                          <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/item photo.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div>
                          <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/item photo.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div>
                          <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/item photo.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Awadhi Murg Korma</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div> -->
                      </div>
                    </ng-container>

                    <ng-container *ngIf="review.amenities?.length">
                      <div class="heads">
                          <p>{{'content3.Amenities' | translate}}</p>
                      </div>
                      <!-- <ngb-rating [max]="5" [(rate)]="rate" [readonly]="true" [starTemplate]="line" class="line-rating">
                          <ng-template #line let-fill="fill">
                              <i class="line" [ngClass]="{'line-o yellow' : fill > 0 , 'line' : fill == 0}">
                                  <i class="line-o filled" [style.width.%]="fill"
                                      [ngClass]="{'line-o' : fill == 0 , 'line' : fill > 0}"></i>
                              </i>
                          </ng-template>
                      </ngb-rating> -->

                      <div class="rating-list">
                          <div class="rate-item d-flex" *ngFor="let amenity of review.amenities">
                              <ng-container *ngIf="amenity.amenitiesRateType == 'StarRating'">
                                  <div class="img-card">
                                      <span *ngIf="!amenity.amenitiesIcon" class="d-block m-auto pt-0">{{ amenity.amenitiesName | shortName }}</span>
                                      <img class="d-block m-auto" *ngIf="amenity.amenitiesIcon" [src]="amenity.amenitiesIcon"
                                          (error)="amenity.amenitiesIcon = ''">
                                      <!-- <img [src]="amenity.amenitiesIcon"> -->
                                  </div>
                                  <span class="font-14 fontMedium text-color ml-2">{{amenity.amenitiesName}}</span>
                                  <ng-container *ngIf="amenity.amenitiesRate != 0; else skipped">
                                    <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                                    <span class="font-15 fontMedium text-color ml-2">{{amenity.amenitiesRate}}</span>
                                  </ng-container>
                                  <ng-template #skipped>
                                    <p class="ml-auto d-flex align-items-center">{{ 'reviews.skipped' | translate }}</p>
                                  </ng-template>
                              </ng-container>
                              <ng-container *ngIf="amenity.amenitiesRateType == 'DashRating'">
                                  <div class="img-card">
                                      <img class="d-block m-auto" [src]="amenity.amenitiesIcon">
                                  </div>
                                  <span class="font-14 fontMedium text-color ml-2">{{amenity.amenitiesName}}</span>
                                  <ng-container *ngIf="amenity.amenitiesRate != 0; else skipped">
                                    <ngb-rating [max]="5" [(rate)]="amenity.amenitiesRate" [readonly]="true" [starTemplate]="line"
                                    class="line-rating ml-auto">
                                    <ng-template #line let-fill="fill">
                                      <i class="line" [ngClass]="{'line-o yellow' : fill > 0 , 'line' : fill == 0}">
                                        <i class="line-o filled" [style.width.%]="fill"
                                          [ngClass]="{'line-o' : fill == 0 , 'line' : fill > 0}"></i>
                                      </i>
                                    </ng-template>
                                  </ngb-rating>
                                  <span class="font-15 fontMedium text-color ml-2 mt-2">{{amenity.amenitiesRate}}</span>
                                  </ng-container>
                                  <ng-template #skipped>
                                    <p class="ml-auto d-flex align-items-center">{{ 'reviews.skipped' | translate }}</p>
                                  </ng-template>
                              </ng-container>
                          </div>
                          <!-- <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/comfort-ic.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div>
                          <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/comfort-ic.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div>
                          <div class="rate-item d-flex">
                              <div class="img-card">
                                  <img src="./assets/images/icons/comfort-ic.svg">
                              </div>
                              <span class="font-14 fontMedium text-color ml-2">Comfort</span>
                              <img class="ml-auto mt-2" width="4%" src="./assets/images/icons/stars.svg" alt="">
                              <span class="font-15 fontMedium text-color ml-2">4.0</span>
                          </div> -->
                      </div>
                    </ng-container>

                    <div class="heads pt-1 pb-1">
                    </div>

                    <div class="library-list">
                        <p class="font-16 fontRegular">{{review.reviewComment}}</p>

                        <lightgallery class="lightgallery d-block m-auto" [settings]="settings">

                            <div class="gallery-item" *ngFor="let item of review?.reviewPhotos">
                                <a class="view-btn" [href]="item">
                                    <img class="img-responsive d-block m-auto" [src]="item" />
                                </a>

                            </div>
                            <div class="gallery-item" *ngFor="let item of review?.reviewVideos">
                                <a class="video-container view-btn" attr.data-video="{{item}}">
                                    <video [src]="item"></video>
                                </a>
                            </div>

                        </lightgallery>

                    </div>
                </div>
            </ng-container>
        </div>
    </div>

</div>

<app-reservation-details
  *ngIf="selectedReservationId"
  [selectedReservationId]="selectedReservationId"
  [restaurantId]="restaurantId"
  (close)="selectedReservationId = null;">
</app-reservation-details>
